import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { GoToBookingPageButton } from '@/scopes/account/booking-payment/components/GoToBookingPageButton'
import { AccountMenu, HeaderContainer, TopNavigationBarItem } from '@/scopes/common/components/Header'
import { LanguageSwitch } from '@/scopes/common/components/Header/LanguageSwitch'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { useFavouriteProductIdsQuery } from '@/scopes/favourites/domain/hooks'
import styles from './PaymentHeader.module.css'

export function PaymentHeader({ hideNavItems = false }: { hideNavItems?: boolean }) {
  const intl = useIntl()
  const { data: favourites } = useFavouriteProductIdsQuery()
  const links = useConfiguration('links')

  return (
    <HeaderContainer backgroundColor="transparent">
      <GoToBookingPageButton />

      <div className={styles.iconsWrapper}>
        <LanguageSwitch />
        {!hideNavItems && (
          <>
            <TopNavigationBarItem
              as="a"
              href={links.favourites}
              aria-label={intl.formatMessage({ id: 'header_my_favourites' })}
              data-qa="favourites-link"
              data-qa-favourites-count={favourites?.length ?? 0}
            >
              <Icon glyph="Heart" className={styles.favoritesIcon} />
              <Typography>{favourites?.length ?? 0}</Typography>
            </TopNavigationBarItem>
          </>
        )}
        <AccountMenu />

      </div>
    </HeaderContainer>
  )
}
